import React, { useState, useEffect } from "react";
import { ChevronRight } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";
import moment from "moment";
import apilink from "../apiURL/baseUrls";
import axios from "axios";

import { getAllRecords, updateRecord, SALES_STORE, USERS_STORE, clearAllRecords, addRecord, markRecordsAsSynced } from "../dbControllers/dbController";


const More = () => {
  const navigate = useNavigate();
  const [syncing, setSyncing] = useState(false);
  const [sales, setSales] = useState([]);
  const [users, setUsers] = useState([]);
  const [changepin, setChangepin] = useState(false);
  const [posting, setPosting] = useState(false);
  const [authId, setAuthId] = useState("");
  const [shopId, setShopId] = useState("");
  const [shopName, setShopName] = useState("");
  const [cashierId, setCashierId] = useState("");
  const [cashierName, setCashierName] = useState("");
  const [oldPin, setOldPin] = useState("");
  const [newPin, setNewPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");

  async function hasInternet() {
    try {
      const response = await fetch("https://example.com/favicon.ico", { method: "HEAD", cache: "no-cache" });
      return response.ok;
    } catch (err) {
      return false;
    }
  }

  const handlePinChange = async () => {
    const sessionData = await JSON.parse(
      localStorage.getItem("userData")
    );

    const asyncPin = sessionData.password;

    console.log(asyncPin)

    if (oldPin !== asyncPin) {
      toast.warn("Error. Current pin is wrong", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (newPin != confirmPin) {
      toast.warn("Error. Wrong pin confirmation", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    const usrObj = {
      id: cashierId,
      password: newPin
    }

    console.log(usrObj);

    updateRecord("users", usrObj).then(() => {
      // Get existing user data from localStorage
      const sessionData = JSON.parse(localStorage.getItem("userData"));

      // Check if it exists
      if (sessionData) {
        // Update the password field
        sessionData.password = newPin;
        // Save it back to localStorage
        localStorage.setItem("userData", JSON.stringify(sessionData));
      }

      toast.success("New password saved", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setOldPin("");
      setNewPin("");
      setConfirmPin("");
    }).catch((err) => {
      console.error("Update failed:", err);
    });



  };
  const handleSignOut = () => {
    navigate("/");
  };

  async function resetAppData() {
    await clearAllRecords("users");
    await clearAllRecords("products");
    await clearAllRecords("otherproducts");
    await clearAllRecords("rates");

    console.log("✅ All stores cleared successfully!");
  }

  async function syncSalesInDb(id) {
    await markRecordsAsSynced("sales", id);
    console.log("✅ Records marked as synced inside");
  }

  const syncSales = async () => {

    //const online = await hasInternet();
    // if (online == false){
    //   toast.warn("Error. Connect to internet first", {
    //     position: "top-center",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: false,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "light",
    //   });
    //   return;
    // }
    setPosting(true);

    let lastId = 0;

    if (sales.length) {
      // Get the last object
      const lastObject = sales[sales.length - 1];

      // Get its id
      lastId = lastObject.id;

    }

    console.log(lastId); // Output: 3
    const dataObj = {
      sales,
      users,
      shopId,
      authId,
      cashierId,
      lastId
    }
    const baseUrl = apilink.link;
    axios
      .post(`${baseUrl}pos/webappsync`, dataObj)
      .then(async (response) => {
        setPosting(false);
        console.log(response.data);
        if (response.data.message === "Synced") {
          resetAppData();
          //add users to IndexedDB
          for (const user of response.data.data.users) {
            await addRecord("users", {
              authid: user.authid,
              id: user.id,
              fullname: user.fullname,
              email: user.email,
              phone: user.phone,
              account: user.account,
              password: user.password,
              changepswd: user.changepswd,
              shopid: user.shopid,
              position: user.position,
              shopname: user.shopname,
              location: user.location,
              changedpinat: null,
            });
          }

          // add shopproducts to IndexedDB
          for (const prod of response.data.data.products) {
            await addRecord("products", {
              productid: prod.productid,
              product: prod.product,
              salemode: prod.salemode,
              price: parseFloat(prod.price),
              fromain: prod.total_from_main
            });
          }

          //add nonshopproducts to IndexedDB
          for (const nonshop of response.data.data.nonshopproducts) {
            await addRecord("otherproducts", {
              shopid: nonshop.id,
              shopname: nonshop.shopname,
              productid: nonshop.productid,
              product: nonshop.product,
              salemode: nonshop.salemode,
              price: parseFloat(nonshop.price)
            });
          }

          // add rates to IndexedDB

          const options = {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
          };

          for (const curr of response.data.data.currencyrates) {
            const jsDate = new Date(curr.updated_at.replace(" ", "T"));
            const formatted = jsDate.toLocaleString("en-GB", options);
            await addRecord("rates", {
              currency: curr.currency,
              usdrate: parseFloat(curr.usdrate),
              formatted
            });
          }

          syncSalesInDb(lastId);

          toast.success("Syncing Successfull", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        }
      })
      .catch((err) => {
        setPosting(false);
        console.log(err.response);
        toast.warn(err.response.data.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };
  const goToGatherings = () => {
    navigate("/app/gatherings");
  };
  const goToAdminchat = () => {
    alert("Taking you to whatsapp to chat with family admin");
    //navigate("/profile");
  };
  const goToContributions = () => {
    navigate("/app/contributions");
  };
  const goToHistory = () => {
    navigate("/app/history");
  };

  useEffect(() => {
    const getAsyncData = async () => {

      const sessionData = await JSON.parse(
        localStorage.getItem("userData")
      );

      setAuthId(sessionData.authid);
      setShopId(sessionData.shopid);
      setShopName(sessionData.shopname);

      setCashierId(sessionData.id);
      setCashierName(sessionData.fullname);

      const allSales = await getAllRecords(SALES_STORE);
      const unsyncedSales = allSales.filter(sale => sale.synced == 0);
      setSales(unsyncedSales);
      const allUsers = await getAllRecords(USERS_STORE);
      setUsers(allUsers);

    };
    getAsyncData();
  }, []);

  return (
    <>
      <p style={{ fontFamily: "Open Sans", fontSize: "14" }}>More</p>
      {/* <div
        onClick={goToProfile}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#EA6C82",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Profile
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div> */}
      <div
        onClick={syncSales}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#EA6C82",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >

        {posting === false && <><p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Sync Sales To Server
        </p></>}
        {posting && (
          <>
            <Squares />
          </>
        )}

        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div>
      <div
        onClick={() => setChangepin(!changepin)}
        style={changepin ? {
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#EA6C82",
          height: "50px",
          width: "100%",
          borderTopLeftRadius: "5px",
          borderTopRightRadius: "5px",
        } : {
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#EA6C82",
          height: "50px",
          width: "100%",
          borderRadius: "5px"
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Change Password
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div>
      {changepin && <>
        <div
          style={{
            alignItems: "center",
            paddingInline: "10px",
            paddingBottom: "10px",
            flexDirection: "column",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#EA6C8230",
            width: "100%",
            borderBottomLeftRadius: "5px",
            borderBottomRightRadius: "5px",
            borderColor: "#EA6C82",
            borderWidth: "1px",
          }}
        >
          <input
            placeholder={"Current Password"}
            style={{
              width: "100%",
              borderWidth: 1,
              borderColor: "#EA6C82",
              borderRadius: 5,
              height: 50,
              fontFamily: "Open Sans",
              fontSize: 14,
              paddingInline: 10,
              marginTop: 10,
            }}
            type="password"
            value={oldPin}
            onChange={(e) => setOldPin(e.target.value)}
          />
          <input
            placeholder={"Old Password"}
            style={{
              width: "100%",
              borderWidth: 1,
              borderColor: "#EA6C82",
              borderRadius: 5,
              height: 50,
              fontFamily: "Open Sans",
              fontSize: 14,
              paddingInline: 10,
              marginTop: 10,
            }}
            type="password"
            value={newPin}
            onChange={(e) => setNewPin(e.target.value)}
          />
          <input
            placeholder={"Old Password"}
            style={{
              width: "100%",
              borderWidth: 1,
              borderColor: "#EA6C82",
              borderRadius: 5,
              height: 50,
              fontFamily: "Open Sans",
              fontSize: 14,
              paddingInline: 10,
              marginTop: 10,
            }}
            type="password"
            value={confirmPin}
            onChange={(e) => setConfirmPin(e.target.value)}
          />

          <button
            onClick={() => handlePinChange()}
            style={{
              width: "315px",
              backgroundColor: '#547FF7',
              borderRadius: 5,
              border: "none",
              height: 50,
              fontFamily: "Open Sans",
              fontSize: 14,
              color: "white",
              marginTop: "10px",
              alignSelf: "flex-end"
            }}
            className="form-control"
          >
            Change Password
          </button>

        </div>
      </>}
      <div
        onClick={() => handleSignOut()}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#EA6C82",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Sign Out
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default More;
